import React, { Component } from 'react';
import { View, ScrollView, StyleSheet } from 'react-native';
import { COLOR, FONT, FONT_SIZE, THEME } from '../../constants/styles';

import { OPScreenComponent, NavBar, Utils } from '../components';

import EventDateTime from './event_date_time';

export default class EventDateTimeScreen extends OPScreenComponent {
  constructor(props) {
    super(props);

    this.state = {
      startDate: props.startDate,
      endDate: props.endDate,
      allDay: props.allDay,
      timeZone: props.timeZone,
    };

    if (props.asModal) {
      this._instanceButtons = {
        leftButtons: [NavBar.buttons.done],
      };
    }
  }

  componentDidMount() {
    Utils.trackScreen('Calendar', 'Date Picker');

    super.componentDidMount();
  }

  componentWillUnmount() {
    let { startDate, endDate, allDay, timeZone } = this.state;
    this.props.onSelect && this.props.onSelect({ startDate, endDate, allDay, timeZone });

    super.componentWillUnmount();
  }

  setStartDate = (startDate) => {
    this.setState({ startDate });
  };

  setEndDate = (endDate) => {
    this.setState({ endDate });
  };

  setAllDay = (allDay) => {
    this.setState({ allDay });
  };

  setTimeZone = (timeZone) => {
    this.setState({ timeZone });
  };

  render() {
    return (
      <View style={THEME.containerAlt}>
        <ScrollView alwaysBounceVertical={false} contentContainerStyle={styles.scrollViewContent}>
          <EventDateTime
            timeZone={this.props.timeZone}
            startDate={this.props.startDate}
            endDate={this.props.endDate}
            allDay={this.props.allDay}
            onStartDate={this.setStartDate}
            onEndDate={this.setEndDate}
            onAllDay={this.setAllDay}
            onTimeZone={this.setTimeZone}
            componentId={this.props.componentId}
            hideTimeZone={this.props.hideTimeZone}
            dateForDefaultEndTime={this.props.dateForDefaultEndTime}
          />
        </ScrollView>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  scrollViewContent: {
    paddingTop: 40,
  },
});
